import { render, staticRenderFns } from "./ServiceTypeEditor.vue?vue&type=template&id=58d7769a&scoped=true"
import script from "./ServiceTypeEditor.vue?vue&type=script&lang=js"
export * from "./ServiceTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d7769a",
  null
  
)

export default component.exports